// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addparts_container {
  width: 100%;
  display: flex;
  overflow: hidden;
  height: 100vh;
}
.addparts_container .Addpartsmain {
  width: 100%;
  background: #ffffff;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 66px);
  scrollbar-width: none;
}
.addparts_container .Addpartsmain::-webkit-scrollbar {
  width: 0px;
}
.addparts_container .Addpartsmain::-webkit-scrollbar-thumb {
  background: transparent;
}
.addparts_container .footer_div {
  z-index: 999;
}

.addpart-added-text {
  font-family: "Nunito";
  font-size: 15px;
  font-weight: 500;
  color: #0C3688;
  margin: 1rem;
}

.AddPartsontainers {
  height: auto;
}
.AddPartsontainers .AddPartsFirst_Para {
  display: flex;
  justify-content: space-between;
  width: 96%;
  margin: 1rem;
}
.AddPartsontainers .AddPartsFirst_Para > span {
  font-family: Nunito;
  font-size: 20px;
  font-weight: 600;
  color: #10132E;
}
.AddPartsontainers .AddPartsFirst_Para > button {
  background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);
  font-family: Nunito;
  font-size: 16px;
  font-weight: 700;
  color: white;
  border-radius: 5px;
  width: 8%;
}

@media screen and (max-width: 480px) {
  .addparts_container {
    display: flex;
    flex-direction: column;
  }
  .Addpartsmain {
    width: 100% !important;
  }
  .AddPartsFirst_Para > button {
    width: 20% !important;
  }
  .AddPartsFirst_Para {
    width: 90% !important;
    margin: auto !important;
    margin-top: 20px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/AddParts/addparts.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;AAAF;AAEI;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EAUA,qBAAA;AATN;AACM;EACE,UAAA;AACR;AAEM;EACE,uBAAA;AAAR;AAME;EACE,YAAA;AAJJ;;AAQA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AALA;;AASA;EACA,YAAA;AANA;AAOA;EACA,aAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;AALA;AAOA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AALA;AAQA;EACA,mEAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AANA;;AAWA;EACA;IACE,aAAA;IACA,sBAAA;EARA;EAUF;IACE,sBAAA;EARA;EAUF;IACA,qBAAA;EARE;EAWF;IACE,qBAAA;IACA,uBAAA;IACA,2BAAA;EATA;AACF","sourcesContent":["\n.addparts_container {\n  width: 100%;\n  display: flex;\n  overflow: hidden;\n  height: 100vh;\n\n    .Addpartsmain {\n      width: 100%;\n      background: #ffffff;\n      overflow-y: auto;\n      overflow-x: hidden;\n      height: calc(100vh - 66px);\n  \n      &::-webkit-scrollbar {\n        width: 0px;\n      }\n  \n      &::-webkit-scrollbar-thumb {\n        background: transparent;\n      }\n  \n      scrollbar-width: none;\n    }\n\n  .footer_div{\n    z-index: 999;\n  }\n}\n\n.addpart-added-text{\nfont-family: \"Nunito\";\nfont-size: 15px;\nfont-weight: 500;\ncolor: #0C3688;\nmargin: 1rem;\n}\n\n\n.AddPartsontainers{\nheight: auto;\n.AddPartsFirst_Para{\ndisplay: flex;\njustify-content: space-between;\nwidth: 96%;\nmargin: 1rem;\n}\n.AddPartsFirst_Para >span{\nfont-family: Nunito;\nfont-size: 20px;\nfont-weight: 600;\ncolor: #10132E;\n\n}\n.AddPartsFirst_Para > button{\nbackground: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);\nfont-family: Nunito;\nfont-size: 16px;\nfont-weight: 700;\ncolor: white;\nborder-radius: 5px;\nwidth: 8%;\n\n}\n}\n\n@media screen and (max-width: 480px) {\n.addparts_container{\n  display: flex;\n  flex-direction: column;\n}\n.Addpartsmain{\n  width: 100% !important;\n}\n.AddPartsFirst_Para > button{\nwidth: 20% !important;\n\n}\n.AddPartsFirst_Para{\n  width: 90% !important;\n  margin: auto !important;\n  margin-top: 20px !important;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
